import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/activities/stockOut.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, IconRemoteControl, DatePicker, Tabs, List, ListItem, IconReload, Checkbox, Accordion, AccordionItemInterface, IconX, IconCheckmark, AccordionInterface, IconCheckmarkCircle, Card, IconSave, TextArea, IconChevronRight, IconWarning } from "@veneer/core";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { decryptText } from "../../utils/encryptionUtils";
import appointmentService from "../../services/agendaApi/appointment.service";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import stockOutService from "../../services/agendaApi/stockOut.service";
import BackButton from "../../features/path/backButton";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { IStockOutAlertDetails, IStockOutIn } from "../../models/input/agendaApi/IStockOutIn";


export default function StockOutAppointment() {

    const params = useParams();
    const [t] = useTranslation("global");
    const state: any = useSelector((state: RootState) => state.user);



    const [search, setSearch] = useState<string>('');

    //Loadings
    const [loadingTableData, setLoadingTableData] = useState(false);



    //Shows
    const [showModalRegisterStockOut, setShowModalRegisterStockOut] = useState(false);

    //Data
    const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
    const [activityId, setActivityId] = useState(NaN);
    const actualPosCode = useRef('');
    const [tableData, setTableData] = useState<TableData[]>([]);
    const [tableDataFiltered, setTableDataFiltered] = useState<TableData[]>([]);
    const [viewStockOutModal, setViewStockOutModal] = useState<number>(0);
    const [notes, setNotes] = useState<string>('');

    const [modifyValues, setModifyValues] = useState<IStockOutAlertDetails[]>([]);

    useEffect(() => {
        setLoadingTableData(true)
        getPosCode()
        let id = Number(params.id);
        let activityId = Number(params.activityId);
        setActivityId(id)
        setAppointmentActivityId(activityId);
    }, [])



    const getPosCode = () => {
        let id = Number(params.id);
        let appointmentResponse: IAppointmentDto[] = [];
        appointmentService.getAppointmentByUser()
            .then(r => {
                appointmentResponse = r;
            }).finally(() => {
                let posCode = appointmentResponse.find(x => x.appointmentId === id)?.posCode;
                if (posCode) {
                    actualPosCode.current = posCode;
                    getStockOut(posCode);
                } else { alert("Error") }

            })
    }

    const getStockOut = (posCode: string) => {
        stockOutService.getStockOut(posCode).then(r => {
            fillDataStockOut(r)
        });
    }

    const fillDataStockOut = (data: IStockOutAlertDetails[]) => {
        const dataTemp: TableData[] = [];
        for (let i = 0; i < data.length; i++) {
            const stock: IStockOutAlertDetails = data[i];
            dataTemp.push({
                'productName': stock.productName,
                'sku': stock.sku,
                'flag': stock.flag,
            })
        }
        setTableData(dataTemp);
        setTableDataFiltered(dataTemp);
        setLoadingTableData(false)

    }


    const columnsWidth: TableColumnWidth[] = [

        {
            columnId: 'productName',
            width: "85%"
        },
        {
            columnId: 'flagCheckBox',
            width: "15%"
        },


    ]

    const tablePreferences: TablePreferences = {
        width: columnsWidth
    }

    const columns: TableColumns[] = [
        {
            id: 'productName',
            label: t("header.productName"),
        },
        {
            id: 'flagCheckBox',
            label: t("header.stockOut"),
        }

    ];

    const handleChangeSearch = (value: string) => {
        setSearch(value);
        if(value !== ''){
            setTableDataFiltered(tableData.filter(filterBySearchTerm));
        }else {
            setTableDataFiltered(tableData)
        }
      };
    
      const filterBySearchTerm = (item: TableData) => {
        if(item.productName.toLowerCase().includes(search.toLowerCase()) || item.sku.toLowerCase().includes(search.toLowerCase())){
            return item;
        }
      };

    const handleChangeFlag = (sku: string) => {
        const updatedData = tableData.map((item) => {
          if (item.sku === sku) {
            return { ...item, flag: !item.flag };
          }
          return item;
        });
        setTableData(updatedData);
        setTableDataFiltered(updatedData.filter(filterBySearchTerm));
      };

    const handleChangeNotes = (value: string) => {
        setNotes(value);
    };

    const onCancelSubmitStockOut = () => {
        setShowModalRegisterStockOut(false)
        setViewStockOutModal(0);
    }

    const onSubmitStockOut = () => {
        let stockOutIn: IStockOutIn[];
        let stockOutDetails: IStockOutAlertDetails[] = [];
        tableData.filter(product => Number(product.flag) !== 0).map((item, index) => {
            stockOutDetails.push({
                sku: item.sku,
                flag: Number(item.flag),
            })
        })

        stockOutIn = [{
            appointmentActivityID: appointmentActivityId,
            notes: notes,
            stockOutAlertDetails: stockOutDetails
        }]

        stockOutService.insertStockOut(stockOutIn)
            .then(r => {
                setViewStockOutModal(0);
                setNotes('')
                setShowModalRegisterStockOut(false)
                setLoadingTableData(true)
                getStockOut(actualPosCode.current)
            })

    }




    return (
        <>

            <div className="stockOut">
                <BackButton route={BreadCrumbsEnum.StockOut} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                <h4 className="stockOutTitle">{t("header.stockOut")}</h4>

                <div className="stockOutDivTop">
                    <TextBox
                        id="searchStockOutTextbox"
                        className="searchStockOutTextbox"
                        label={t("header.search")}
                        type="search"
                        onChange={handleChangeSearch}
                        value={search}
                    />

                    <Button onClick={() => setShowModalRegisterStockOut(true)}>{t("modal.saveTitleInfo")}</Button>

                </div>
                <Card
                    appearance="outlined"
                    className="stockOutDivTable"
                    content={<Table
                        className="stockOutTable"
                        behavior={{
                            type: 'singlePage',
                        }}
                        columnResize
                        preferences={tablePreferences}
                        loading={loadingTableData}
                        columns={columns}
                        data={tableDataFiltered.map((item) => ({
                            sku: item.sku,
                            productName: item.productName,
                            flagCheckBox: (
                                <Checkbox
                                    id={item.sku}
                                    className="stockOutCTableCheckBox"
                                    onChange={() => handleChangeFlag(item.sku)}
                                    value={Boolean(item.flag)}
                                    checked={Boolean(item.flag)}
                                />
                            ),
                        }))}
                        loadingDataLength={10}
                        customNoItems={<div className="customNoItems"><div className="DivIconCustomNoItems"><IconWarningAlt className="IconCustomNoItems" /></div>{t("header.noItemsFound")}</div>}
                    />}
                />

            </div>


            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalRegisterStockOut"
                    closeButton={true}
                    align="center"
                    id="modalRegisterStockOut"
                    show={showModalRegisterStockOut}
                    onClose={onCancelSubmitStockOut}
                    footer={(() => {
                        if (viewStockOutModal === 0) {
                            return (
                                <ButtonGroup className="registerSaleButtongrouop">
                                    <Button onClick={() => setViewStockOutModal(1)} >{t("header.next")}</Button>
                                    <Button onClick={onCancelSubmitStockOut} appearance="secondary">{t("header.cancel")}</Button>
                                </ButtonGroup>
                            )

                        } else if (viewStockOutModal === 1) {
                            return (
                                <ButtonGroup className="registerSaleButtongrouop">
                                    <Button onClick={onSubmitStockOut} >{t("header.save")}</Button>
                                    <Button onClick={onCancelSubmitStockOut} appearance="secondary">{t("header.cancel")}</Button>
                                </ButtonGroup>
                            )
                        }
                    })()}

                    title={t("header.saveInformation")}
                >

                    {(() => {
                        if (viewStockOutModal === 0) {
                            return (
                                <div className="registerStockOut">
                                    <TextArea
                                        id="textAreaStockOut"
                                        className="textAreaStockOut"
                                        label={t("header.notes")}
                                        value={notes}
                                        onChange={e => handleChangeNotes(String(e))}
                                    />
                                </div>
                            )

                        } else if (viewStockOutModal === 1) {
                            return (
                                <div>
                                    <IconSave size={120} />
                                    <br />
                                    <b>{t("modal.saveMessage")}</b>
                                </div>

                            )
                        }
                    })()}

                </Modal>
            </div>



        </>


    );
}